// @flow
import {
  call,
  put,
  takeEvery,
}                                              from 'redux-saga/effects';
import type { SaveRequestActionAfterDispatch } from '../../actions/apiResourceActions';
import {
  saveApiResourceFailure,
  saveApiResourceRequest,
  saveApiResourceSuccess,
}                                              from '../../actions/apiResourceActions';
import UserFriendlyError                       from '../../errors/UserFriendlyError';
import Raven                                   from '../../modules/raven-cdn';
import API                                     from '../../services/API';


function* handleApiSaveRequests(): Generator<void, void, void> {

  yield takeEvery(saveApiResourceRequest, saveApiResource);

}


/**
 *
 * @param {{uuid: Identifier, resourceIRI: string, method: string, dataToSave: object}} action
 *
 * @return {IterableIterator<*>}
 */
function* saveApiResource(action: SaveRequestActionAfterDispatch) {

  const {payload: {resourceIRI, method, dataToSave}} = action;

  const callYield = call(API.save, resourceIRI, method, dataToSave);

  const nextActionCommonArgs = {...action.payload, ...action.meta};

  try {

    const receivedData: $ReadOnly<{}> = yield callYield;

    if (!receivedData) {

      // noinspection ExceptionCaughtLocallyJS
      throw new UserFriendlyError('Sorry.  We were unable to save your changes.');

    }

    const successAction = saveApiResourceSuccess({...nextActionCommonArgs, receivedData});

    yield put(successAction);

  } catch (error) {

    Raven.captureException(error);

    const failureAction = saveApiResourceFailure(error, nextActionCommonArgs);

    yield put(failureAction);

  }

}


export default handleApiSaveRequests;



// WEBPACK FOOTER //
// ./src/sagas/resources/handleApiSaveRequests.js